import doc                     from 'decorators/doc';
import model                   from 'decorators/model';
import SupplierPrivateApiModel from '../../abstracts/SupplierPrivateApiModel';

@model.cacheDuration()
@model.staticLabel('Statut')
@model.urnResource('supplier_enterprise_status')
@doc.path('/supplier_enterprise_statuses/{?id}')
export default class SupplierEnterpriseStatusModel extends SupplierPrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'reference': SupplierSupplierEnterpriseStatusReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
	}> = {};

	@doc.string declare label: string;
	@doc.string declare reference: SupplierSupplierEnterpriseStatusReference;

	public get color() {
		switch (this.reference) {
			case 'pending':
				return 'lightblue';
			case 'validated':
				return 'green';
			case 'disabled':
				return 'red';
		}
	}
}